import React, { useState, useEffect, useMemo, Fragment, useRef } from "react";
import { Helmet } from "react-helmet";
import AddrPopup from "@components/AddrPopup";
import { comma, getAddress } from '@src/util/helper'
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadScript from "@util/loadScript";
import { createOrder, fakeOrder, validate, createOrderNo } from "@pages/common/common";
import { emailRegex } from "@util/helper";
import { showSnackbar } from "@context/SnackbarContext";

import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  Button,
  Checkbox,
  RadioGroup,
  IconButton,
} from '@mui/material'
import useIndicator from '@hooks/useIndicator'
import moment from "moment";
import ContractDownloader from "@components/ContractDownloader";
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined'
import ConfirmDialog from '@components/ConfirmDialog'
import WebService from "@util/webService";
import '@scss/App.scss'
const Test = () => {
  const theme = useTheme()
  const inputsRef = useRef({})
  const confirmRef = useRef(null)
  const [payInfo, set_payInfo] = useState({})
  const removeNonDigits = (input) => {
    return input.replace(/\D/g, '')
  }
  const onNext = () => {

  }
  const fetchPayInfo = async() => {
    const url = `/public/pay/info`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      showSnackbar('결제사정보를 가져올 수 없습니다.')
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const payInfo = JSON.parse(repMessage.payInfo)
    console.log('payInfo=>', payInfo)
    set_payInfo(payInfo)
  }

  const handleChange = (e) => {

    if(e.target.name === 'repPhone' || e.target.name === 'contactPhone') {
      const newVal =  removeNonDigits(e.target.value)
      inputsRef.current[e.target.name].value = newVal
    }

    if(e.target.name === 'civilNum1' || e.target.name === 'civilNum2')  {
      const newVal =  removeNonDigits(e.target.value)
      inputsRef.current[e.target.name].value = newVal
    }

    if(e.target.name === 'bizNum1' || e.target.name === 'bizNum2' || e.target.name === 'bizNum3') {
      const newVal =  removeNonDigits(e.target.value)
      inputsRef.current[e.target.name].value = newVal
    }

    if(e.target.name === 'corpNum1' || e.target.name === 'corpNum2') {
      const newVal =  removeNonDigits(e.target.value)
      inputsRef.current[e.target.name].value = newVal
    }
  }


  const payRequest = () => {
    const order = createOrder()
    order.orderNo = createOrderNo()
    window.cookiepayments.payrequest({
        ORDERNO: order.orderNo, //주문번호 (필수)
        PRODUCTNAME: 'P001', //상품명 (필수)
        AMOUNT: 500, //결제 금액 (필수)
        BUYERNAME: '홍길동', //고객명 (필수)
        // BUYEREMAIL: $("#BUYEREMAIL").val(), //고객 e-mail (선택)
        PAYMETHOD: 'CARD', //결제 수단 (선택)
        // PRODUCTCODE: $("#PRODUCTCODE").val(), //상품 코드 (선택)
        // BUYERID: $("#BUYERID").val(), //고객 아이디 (선택)
        // BUYERADDRESS: $("#BUYERADDRESS").val(), //고객 주소 (선택)
        // BUYERPHONE : $("#BUYERPHONE").val(), //고객 휴대폰번호 (선택, 웰컴페이는 필수)
        RETURNURL: payInfo.returnUrl,
        ENC_YN: 'Y'
        // RETURNURL: `https://sandbox.cookiepayments.com/payRec/pay_success`, //결제 완료 후 리다이렉트 url (필수)
    });
  }

  const TxtTmpl = ({label, field,  required}) => {
    return(
      <TextField 
        label={label} 
        required={required}
        fullWidth
        defaultValue={'11111'}
        name= {field}
        inputRef = {el => inputsRef.current[field] = el}
        onChange={handleChange}
      />
    )
  }

  useEffect(() => {
    fetchPayInfo()
  },[])

  useEffect(() => {
    if(payInfo.apiId) {
      window.cookiepayments.init({
          api_id: payInfo.apiId
          // api_id: 'sandbox_Cm3uFiy3ZR'
      }); 
    }
  },[payInfo])

  return (
    <div style={{marginTop:30}}>
      <Button onClick={() => {
        payRequest()
      }}>
      결제
      </Button>
    </div>
  )
}

export default Test
